/**
 * @generated SignedSource<<23472da8690c7a569cb6cd88139d81e2>>
 * @relayHash 684c99782ab0cc42dc996ee8aab6deba
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fb7d60e06049aa671fdef2c76df8ba70295f8dceaab039dc26228c158109adc6

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type accountGeneralSettingsPageQuery$variables = {
  account: string;
};
export type accountGeneralSettingsPageQuery$data = {
  readonly accountBySlug: {
    readonly " $fragmentSpreads": FragmentRefs<"organizationIdFragment" | "organizationNameFragment" | "organizationSlugFragment">;
  };
};
export type accountGeneralSettingsPageQuery = {
  response: accountGeneralSettingsPageQuery$data;
  variables: accountGeneralSettingsPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "account"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "account"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "accountGeneralSettingsPageQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "alias": null,
          "args": (v1/*: any*/),
          "concreteType": null,
          "kind": "LinkedField",
          "name": "accountBySlug",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "organizationSlugFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "organizationNameFragment"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "organizationIdFragment"
            }
          ],
          "storageKey": null
        },
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "accountGeneralSettingsPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "accountBySlug",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "TypeDiscriminator",
            "abstractKey": "__isAccount"
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "slug",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "684c99782ab0cc42dc996ee8aab6deba",
    "id": "fb7d60e06049aa671fdef2c76df8ba70295f8dceaab039dc26228c158109adc6",
    "metadata": {},
    "name": "accountGeneralSettingsPageQuery",
    "operationKind": "query",
    "text": "query accountGeneralSettingsPageQuery(\n  $account: String!\n) {\n  accountBySlug(slug: $account) {\n    __typename\n    ...organizationSlugFragment\n    ...organizationNameFragment\n    ...organizationIdFragment\n    id\n  }\n}\n\nfragment organizationIdFragment on Account {\n  __isAccount: __typename\n  id\n}\n\nfragment organizationNameFragment on Account {\n  __isAccount: __typename\n  id\n  name\n}\n\nfragment organizationSlugFragment on Account {\n  __isAccount: __typename\n  id\n  slug\n}\n"
  }
};
})();

(node as any).hash = "7b4009c7fb3dcf9b3a20795c97d7aa23";

export default node;
